var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.confirmDeleteEntity()}}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'trash']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }